import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import SvgIcon from '@material-ui/core/SvgIcon';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';

import { UserMenu, ActionMenu, CreateMenu, Navigation } from './components';
import './Header.scss';

const useStyles = makeStyles((theme) => ({
  logo: { marginRight: '40px' },
  logoIcon: {
    height: '24px',
    width: '120px',
    color: '#fff',
    fill: '#fff',
  },
}));

const Header = ({ workspace }) => {
  const classes = useStyles();
  const [suspended, setSuspended] = useState(false);
  useEffect(() => {
    if (workspace && workspace.get('status') === 'suspended') {
      setSuspended(true);
    } else {
      setSuspended(false);
    }
  }, [workspace]);

  const logo = (
    <SvgIcon className={classes.logoIcon} viewBox="0 0 393 79" color="inherit">
      <polygon
        id="Path"
        fill="currentColor"
        points="27.8125 12 50 40.4 72.1875 12 100 12 50 76 0 12"
      ></polygon>
      <polygon
        id="Triangle"
        transform="translate(50.000000, 14.800000) scale(1, -1) translate(-50.000000, -14.800000) "
        points="50 2 70 27.6 30 27.6"
      ></polygon>
      <path
        d="M174.798808,77 L151.317437,77 L124,1 L145.040238,1 L159.105812,46.9454545 L163.290611,61.9151515 L167.359165,47.1757576 L181.657228,1 L202,1 L174.798808,77 Z M231,77 L211,77 L211,1 L231,1 L231,77 Z M278.100511,0 C285.360059,1.37580579e-14 291.557612,1.08430288 296.693356,3.25294118 C301.8291,5.42157947 306.597934,8.94556384 311,13.825 L299.763203,26.8367647 C297.214638,22.9641963 294.22205,20.1179013 290.785349,18.2977941 C287.348648,16.477687 283.236253,15.5676471 278.448041,15.5676471 C274.432121,15.5676471 271.342998,16.2646989 269.180579,17.6588235 C267.018161,19.0529481 265.936968,20.9117531 265.936968,23.2352941 C265.936968,25.1715783 267.076082,26.739945 269.354344,27.9404412 C271.632607,29.1409374 275.513317,30.2446028 280.996593,31.2514706 C291.576998,33.1877548 299.126042,36.0146873 303.643952,39.7323529 C308.161862,43.4500186 310.420784,48.6779075 310.420784,55.4161765 C310.420784,60.2956126 309.030678,64.5166489 306.250426,68.0794118 C303.470173,71.6421747 299.628077,74.3529319 294.72402,76.2117647 C289.819964,78.0705975 284.27885,79 278.100511,79 C269.450837,79 262.423082,77.9350597 257.017036,75.8051471 C251.610989,73.6752344 246.938691,70.4029632 243,65.9882353 L253.194208,52.0470588 C256.206148,56.2294327 259.604183,59.1725405 263.388416,60.8764706 C267.172648,62.5804007 271.729105,63.4323529 277.057922,63.4323529 C281.305529,63.4323529 284.491188,62.8321138 286.614991,61.6316176 C288.738795,60.4311214 289.800681,58.7078544 289.800681,56.4617647 C289.800681,54.6803832 288.661567,53.2281919 286.383305,52.1051471 C284.105043,50.9821022 280.30156,49.9171619 274.972743,48.9102941 C268.408258,47.5936209 262.982986,46.0252542 258.696763,44.2051471 C254.410541,42.3850399 251.089734,39.9259959 248.734242,36.8279412 C246.37875,33.7298865 245.201022,29.779926 245.201022,24.9779412 C245.201022,20.1759564 246.494592,15.87747 249.081772,12.0823529 C251.668951,8.28723593 255.453127,5.32476555 260.434412,3.19485294 C265.415698,1.06494033 271.304339,1.37580579e-14 278.100511,0 Z M354.575456,49.2484848 L342.618574,49.2484848 L342.618574,77 L323,77 L323,1 L359.567164,1 C368.854109,1 375.993342,3.07270655 380.985075,7.21818182 C385.976808,11.3636571 388.472637,17.351476 388.472637,25.1818182 C388.472637,30.7091185 387.195701,35.3151331 384.641791,39 C382.087881,42.6848669 378.373159,45.4100922 373.497512,47.1757576 L393,77 L370.943615,77 L354.575456,49.2484848 Z M342,35 L355.702703,35 C359.997018,35 363.12011,34.2415246 365.072072,32.7245509 C367.024034,31.2075772 368,28.7804558 368,25.4431138 C368,22.1816204 367.024034,19.7924228 365.072072,18.2754491 C363.12011,16.7584754 359.997018,16 355.702703,16 L342,16 L342,35 Z"
        id="VISR"
      ></path>
    </SvgIcon>
  );

  return (
    <AppBar>
      <Toolbar>
        <Link to="/" className={classes.logo}>
          {logo}
        </Link>
        {!suspended ? <Navigation /> : <div style={{ flex: '1' }}></div>}
        <div>
          <Grid container>
            {!suspended ? (
              <Grid item>
                <CreateMenu />
              </Grid>
            ) : null}
            {/* <Grid item>
              <ActionMenu />
            </Grid> */}
            <Grid item>
              <UserMenu />
            </Grid>
          </Grid>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
